import { Stack, StackProps, Typography } from "@mui/material";
import { FC, ReactElement, ReactNode } from "react";

type TExportStepProps = Omit<StackProps, "title"> & {
  title?: ReactNode;
};

const ExportStep: FC<TExportStepProps> = ({
  children,
  title,
  ...rest
}: TExportStepProps): ReactElement => {
  return (
    <Stack gap="24px" {...rest}>
      <Typography fontSize="24px" fontWeight={700} variant="h3">
        {title}
      </Typography>
      {children}
    </Stack>
  );
};

export default ExportStep;
